export const WEB_LINKS = {
  dailyChart: "/daily-market",
  annualChartNano: "/annual-market",
  dailyProdAndCons: "/production-consumption",
  production: "/production",
  acquisitionForm: "/acquisition-form",
  spot: "/spot",
  acquisitionThankYou: "/acquisition-thank-you",

  acquisitionFormNew: "/acquisition-form-new/*",
  acquisitionFormNewSecond: "/acquisition-form-new-second/*",
}
